import React from "react";
import { placeholder, useState, useEffect, ImageLargePreview } from "@";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Image = React.memo(
  ({
    src,
    width,
    click,
    style,
    height,
    size = 50,
    alt = "صورة",
    className = "p-1 rounded-2xl",
  }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [imagePreview, setImagePreview] = useState("");

    const handleError = () => {
      setImgSrc(placeholder);
    };

    const clickImage = () => {
      if (click) {
        click();
      } else {
        setImagePreview(imgSrc);
      }
    };

    useEffect(() => {
      setImgSrc(src || placeholder);
    }, [src]);

    return (
      <>
        <ImageLargePreview
          image={imagePreview}
          url={imagePreview}
          hide={() => setImagePreview("")}
        />

        <LazyLoadImage
          alt={alt}
          src={imgSrc}
          style={style}
          onClick={clickImage}
          width={width || size}
          onError={handleError}
          className={`${className} ${!click && "hover:scale-110 hover:cursor-zoom-in"}`}
          height={height || size}
          placeholderSrc={placeholder}
        />
      </>
    );
  },
);

export default Image;
